type TPrefSuff = 'prefix' | 'suffix';
enum EPrefSuff {
  prefix = 'prefix',
  suffix = 'suffix',
}

type DisplayCurrencyOptions = {
  currency?: string | null;
  prefixSuffix?: TPrefSuff;
  fractionDigits?: number;
  compact?: boolean;
};

export const displayCurrency = (
  price: number | string | undefined,
  currencyOrOptions: string | null | undefined | DisplayCurrencyOptions = '€',
  prefixSuffix: TPrefSuff = 'suffix',
  fractionDigits = 2,
) => {
  // Support both old signature and new options object
  let currency: string | null | undefined;
  let finalPrefixSuffix: TPrefSuff;
  let finalFractionDigits: number;
  let compact: boolean;

  if (typeof currencyOrOptions === 'object' && currencyOrOptions !== null) {
    currency = currencyOrOptions.currency ?? '€';
    finalPrefixSuffix = currencyOrOptions.prefixSuffix ?? 'suffix';
    finalFractionDigits = currencyOrOptions.fractionDigits ?? 2;
    compact = currencyOrOptions.compact ?? false;
  } else {
    currency = currencyOrOptions ?? '€';
    finalPrefixSuffix = prefixSuffix;
    finalFractionDigits = fractionDigits;
    compact = false;
  }

  // en nam treba za 1k, 2k i sl. hr-HR za normalno formatiranje s točkama i zarezima
  const locale = compact ? 'en' : 'hr-HR';

  const priceFormatSetter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR', // Always format as EUR internally, symbol will be handled manually
    minimumFractionDigits: finalFractionDigits,
    maximumFractionDigits: finalFractionDigits,
    ...(compact && { notation: 'compact' }),
  });

  const positiveOrNegativeNumber = Math.sign(price === undefined ? 0 : +price);
  let formattedPrice = priceFormatSetter.format(Math.abs(price === undefined ? 0 : +price));

  // Guard against removing numbers: Check if the first character is a digit or currency symbol
  const firstCharIsNumber = /^\d/.test(formattedPrice[0]);
  if (!firstCharIsNumber) {
    // Symbol is at the start, so remove it
    formattedPrice = formattedPrice.substring(1);
  } else {
    // Symbol is at the end, so remove the last character
    formattedPrice = formattedPrice.slice(0, -1);
  }

  // Handle prefix or suffix placement
  if (finalPrefixSuffix === EPrefSuff.prefix && currency) {
    formattedPrice = `${currency} ${formattedPrice}`;
  } else if (currency) {
    formattedPrice = `${formattedPrice} ${currency}`;
  }

  return positiveOrNegativeNumber === -1 ? `-${formattedPrice}` : formattedPrice;
};
